
// reference: https://react-bootstrap.github.io/components.html#custom-styles

import { Button } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';
bootstrapUtils.addStyle(Button, 'catallaxy');




// WEBPACK FOOTER //
// ./src/customize-button.js